import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseButton } from '../../../../../../BaseComponents';
import { useClearExchangeVariants } from '../../model/useClearExchangeVariants';

interface Props {
	label?: string;
	onClick?: () => void;
}

const ClearExchangeVariantsButton: React.FC<Props> = ({ label, onClick }) => {
	const { t } = useTranslation('Exchange');

	const { onClearExchangeVariants } = useClearExchangeVariants();

	const onClickHandler = useCallback(() => {
		onClearExchangeVariants();
		onClick?.();
	}, [onClick, onClearExchangeVariants]);

	return (
		<BaseButton variant="text" onClick={onClickHandler}>
			{label || t('ClearExchangeVariantsButton.Label')}
		</BaseButton>
	);
};

export default ClearExchangeVariantsButton;
